<template>
  <section class="page-section page-section--welcome pt-5">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-10">
          <h1 class="display-4  pb-7"> Welkom bij de <br>Veense veiling! </h1>
          <div class="mb-3">
            <label for="name" class="form-label">Vertel eens, hoe heet je?</label>
            <input type="text" class="form-control" id="name" placeholder="Naam" v-model="name" required>
          </div>
          <button href="" @click="submit" class="btn btn-secondary text-dark text-uppercase mt-3">Ik ben klaar</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { visitor } from '../../stores/visitor';

export default {
  setup() {
    const store = visitor()

    return {
      // you can return the whole store instance to use it in the template
      store,
    }
  },
  data() {
    return {
      name: null,
    };
  },
  mounted() {
    //this.getActiveItem();
  },
  methods: {
    submit(e) {

      let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content;

      axios({
        method: 'POST',
        url: '/api/auction/' + this.getAuctionIdFromUrl() + '/attendee/store',
        data: {'X-CSRF-TOKEN': csrfToken, 'name': this.name},
      })
          .then(response => {
            if (response.data.status && response.data.status == 'success') {
              this.store.$state['id'] = response.data.id;
              this.store.$state['name'] = this.name;
              this.store.$state['number'] = response.data.number;
              this.store.$state['auction'] = response.data.auction;

              localStorage.setItem('hash', response.data.hash);
            }
          });

      e.preventDefault()
    },
    getAuctionIdFromUrl(){
        return parseInt(window.location.pathname.split('/')[2]);
    }
  }
}
</script>
